import { Pipe, PipeTransform } from '@angular/core';
import { TooltipService } from './tooltip.service';
import _ from 'lodash-es';

@Pipe({ name: 'tpbTooltip' })
export class TooltipPipe implements PipeTransform {
  constructor(private tooltipService: TooltipService) {}

  transform(tooltipName: string): string {
    const content = this.tooltipService.getTooltip(tooltipName);

    return _.isEmpty(content) || _.isUndefined(content) ? 'Undefined' : content;
  }
}
